import { IAppGenre } from '@interfaces';

interface IAppSchema {
	id: string;
	title: string;
	description: string;
	genres: IAppGenre[];
	rating: number;
	voters: number;
	image?: string;
}
const MIN = 0;
const MAX = 5;

export const getAppSchema = (app: IAppSchema) => {
	const genreList = app.genres?.length
		? app.genres.map((genre: IAppGenre) => genre.name).join(', ')
		: '';

	return {
		'@context': 'http://www.schema.org',
		'@type': 'VideoGame',
		'name': app.title,
		'image': app.image,
		'description': app.description && app.description.replace(/[\n\r]/g, ' ') || '',
		'genre': genreList,
		'aggregateRating': app.rating
			? {
				'@type': 'aggregateRating',
				'ratingValue': Number(app.rating) || 0,
				'reviewCount': Number(app.voters) || 0,
				'bestRating': MAX,
				'worstRating': MIN,
			}
			: undefined,
	};
};
